module.exports = __webpack_public_path__ + "img/correct.e585d8d0.svg";